import { UserMemberSubscriptionStatus } from "@gymflow/types";
import { useTranslation } from "react-i18next";

import { DotBadge, DotBadgeProps } from "../../DotBadge";
import { CreditPackItemType } from "../CreditPackItem";

type CreditPackItemStatusProps = {
  creditPack: CreditPackItemType;
};

const STATUS_MAP: Partial<
  Record<UserMemberSubscriptionStatus, DotBadgeProps["intent"]>
> = {
  PENDING: "lightblue",
  PAUSED: "warning",
  OVERDUE: "error",
  CANCELLED: "warning",
};

export const CreditPackItemStatus = ({
  creditPack,
}: CreditPackItemStatusProps) => {
  const { status, partOfMembership } = creditPack;
  const { t } = useTranslation();
  const intent = STATUS_MAP[status];

  if (!intent) return null;

  const isPendingMembership = status === "PENDING" && partOfMembership;

  return (
    <>
      <DotBadge intent={intent}>
        {t(`portal.common.subscriptionStatus.${status}`)}
      </DotBadge>
      {status !== "CANCELLED" && !isPendingMembership && (
        <div className="hidden size-1.5 shrink-0 rounded-full bg-gray-300 lg:block" />
      )}
    </>
  );
};
